import type {
  TierId,
  TierLevel,
  TierName,
  Tiers,
} from '@bond/bruce-api/common/tier'

export function getTierNamesByTierId(tiers: Tiers) {
  return tiers.reduce(
    (acc: Record<string, string>, currentTier) => ({
      ...acc,
      [currentTier.id]: currentTier.name,
    }),
    {},
  ) as { [key in TierId]: TierName }
}

export function getTierNamesByTierLevel(tiers: Tiers) {
  return tiers
    .filter((tier) => tier.level !== null)
    .reduce(
      (acc: Record<string, string>, currentTier) => ({
        ...acc,
        [currentTier.level as TierLevel]: currentTier.name,
      }),
      {},
    ) as { [key in TierLevel]: TierName }
}
